import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "John Smith",
    title: "AI Developer",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis in ea expedita libero error aut itaque quia praesentium? Consectetur nam, maxime atque sit eius corporis voluptate? Exercitationem dolorem consequatur voluptatibus?",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Linda Johnson",
    title: "Data Scientist",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis in ea expedita libero error aut itaque quia praesentium? Consectetur nam, maxime atque sit eius corporis voluptate? Exercitationem dolorem consequatur voluptatibus?",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "David Wilson",
    title: "Software Engineer",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Debitis in ea expedita libero error aut itaque quia praesentium? Consectetur nam, maxime atque sit eius corporis voluptate? Exercitationem dolorem consequatur voluptatibus?",
  },
];

export default testimonials;